import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User committed a canvas node toolbar action. Fires at open for prompt/edit_text/translate, on click for vectorize/split_elements/convert_to_gif and Surprise me actions, and on generate/submit for the rest. Pairs with canvas_node_tool_opened; do not sum the two events.',
  name: 'canvas_node_toolbar_action_clicked',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of node the toolbar action was performed on',
      name: 'node_type',
      required: true,
      type: 'enum',
      values: ['image', 'video'],
    },
    {
      description: 'The toolbar action that was clicked',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: [
        'adjust_image',
        'camera_angle',
        'camera_motion',
        'change_lighting',
        'smart_resize',
        'crop',
        'prompt',
        'edit_text',
        'flip_and_rotate',
        'erase',
        'extend_background',
        'remove_background',
        'upscale',
        'convert_to_gif',
        'animate',
        'animate_surprise_me',
        'extend_video',
        'extend_video_surprise_me',
        'vectorize',
        'translate',
        'split_elements',
      ],
    },
    {
      description: 'Variant count selected on the Animate toolbar pill, when the flag is on',
      name: 'variant_count',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
